import React from 'react';
import {StyleSheet, TouchableOpacity, View} from 'react-native';

import Text from '../components/ui-controls/Text';
import config from '../config';
import {AppRoute} from '../models/AppRoute';
import theme from '../style/theme';
import { brandRewardsCopy } from '../utils/rewards';

import * as RootNavigation from './RootNavigation';

type LinkProps = {
  children: React.ReactNode;
  target: string;
};
const Link = ({children, target}: LinkProps) => (
  <TouchableOpacity onPress={() => RootNavigation.push(target)}>
    <Text style={styles.link}>{children}</Text>
  </TouchableOpacity>
);

type WebDesktopTopNavigationProps = {
  storeLoyaltyEnabled: boolean;
  ecommerceDisabled?: boolean;
};

const WebDesktopTopNavigation = ({
  ecommerceDisabled,
  storeLoyaltyEnabled,
}: WebDesktopTopNavigationProps) => (
  <View style={styles.main}>
    <Link target={AppRoute.HOME}>HOME</Link>
    <Link target={AppRoute.SHOP}>SHOP</Link>
    <Link target={AppRoute.DISCOVER}>DISCOVER</Link>
    {config.FF_LOYALTY_ENABLED && storeLoyaltyEnabled ? (
      <Link target={AppRoute.REWARDS}>{brandRewardsCopy.menuTitle.toUpperCase()}</Link>
    ) : (
      !ecommerceDisabled ? <Link target={AppRoute.WISHLIST}>WISHLIST</Link> : null
    )}
    <Link target={AppRoute.CATALOGUE}>CATALOGUES</Link>
    <Link target={AppRoute.PROMOTIONS}>PROMOTIONS</Link>
  </View>
);

export default WebDesktopTopNavigation;

const styles = StyleSheet.create({
  main: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    minHeight: 44,
  },
  link: {
    color: theme.colour.text.drawer.primary,
    paddingRight: '24px',
    paddingLeft: '24px',
    fontWeight: '400',
  },
});
